export const lightTheme = {
  mode: "light",
  body: "#fff",
  text: "#363537",
  toggleBorder: "#070707",
  background: "#363537",
};
export const darkTheme = {
  mode: "dark",
  body: "#2E3440",
  text: "#FAFAFA",
  toggleBorder: "#6B8096",
  background: "#999",
};
